'use strict';

module.exports = document.createElement('div').style;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-kit/builtinStyle.js
 ** module id = 562
 ** module chunks = 1
 **/